import React from 'react';
import { UsagePriceFont } from './BundleCards.styled';

const CfnLabel = ({
    cfn,
    setItemHandler,
    setDetailsData,
    cfnFontColor,
    isShowSetItemDetails,
    cursor,
    isBundle,
    isEquity,
    textAlign
}) => {
    return (
        <UsagePriceFont
            color={cfnFontColor ? cfnFontColor : '#1010EB'}
            fontFamily="AvenirNextWorld Demi"
            fontSize="15px"
            letterSpacing="-0.12px"
            lineHeight="27px"
            margin={isBundle ? '0px 0px 0px 5px' : '0 10px 0px 0px'}
            cursor={cursor}
            onClick={
                isShowSetItemDetails
                    ? () => {
                          setItemHandler(setDetailsData, true);
                      }
                    : () => {}
            }
            display={isEquity ? 'contents' : 'inline-block'}
            textAlign={textAlign}
        >
            {cfn ? cfn : null}
        </UsagePriceFont>
    );
};

export default CfnLabel;
